<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li>
                        <li>About Us</li>
                    </ul>
                </div>
            </section>
            <div class="about-us custom-banner-section">
                <div class="row m-0">
                    <div class="col-md-6 p-0">
                        <div class="about_main_image">
                            <img src="../../assets/images/en-about-banner.jpg" alt="about" />

                            <div class="about_main_title">
                                <h4>About US</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 p-0">

                    </div>
                </div>
            </div>
            <div class="about_content_wrapper">
                <div class="container">
                    <div class="about_content_block">
                        <p>Nama Medical LLC is a Saudi company established in 2014.
                        Head-office is in Riyadh, the capital of Saudi Arabia. Nama
                        Medical has 3 divisions: Digital Healthcare Solutions,
                        Consultancy Services, and Nama Medical Training Center
                        (NMTC). All of these divisions are working together to
                        improve our clients’ performance measures and healthcare
                        outcomes.</p>
                        <p>Nama provides the best digital healthcare solutions and
                        transformation programs. Our products are distinguished
                        by their ability to meet all requirements made by local
                        healthcare authorities. This is possible through our large
                        team of Saudi healthcare consultants and specialists
                        working with Nama-IT professionals and our partners in
                        USA, UK, and India.</p>
                        <p>NMTC is accredited by the Saudi Commission for Health
                        Specialties (SCFHS) to provide continuing professional
                        development and CME hours for healthcare practitioners in
                        Saudi Arabia. Our scopes include but not limited to
                        healthcare quality, patient safety, professional medical
                        education, and research. Today, NMTC has multiple
                        collaboration agreements with Saudi authorities and
                        international non-for-profit institutes aiming to improve
                        healthcare outcomes and have better health through up to
                        date knowledge and training of healthcare practitioners in
                        our region.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
import EventBus from '../EventBus'

export default{
    data(){
        return {
            page_title:null,
            page_content:null
        }
    },
    mounted(){
        // this.get_page_content();
    },
    components:{
        HeaderMenu:HeaderMenu,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/AboutUsEnglish.vue